import { RegistroEntradaVisitanteRoutingModule } from './registro-entrada-visitante-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { RegistroEntradaVisitanteComponent } from './registro-entrada-visitante.component';
import { ModalAsociarTarjetaReutilizableComponent } from './modal-asociar-tarjeta-resutilizable/modal-asociar-tarjeta-reutilizable.component';

@NgModule({
    declarations: [RegistroEntradaVisitanteComponent, ModalAsociarTarjetaReutilizableComponent ],
    imports: [
        RegistroEntradaVisitanteRoutingModule,
        SharedModule,
        CommonModule
    ],
    entryComponents: [ModalAsociarTarjetaReutilizableComponent]
})
export class RegistroEntradaVisitanteModule { }
